<template>
  <div>
    <van-nav-bar title="Talk 工控" left-text="返回" left-arrow @click-left="handleBack"/>
    <CommentBlock v-if="commentInfo" :info="commentInfo" notShowReplay/>
    <div class="title w">全部评论</div>
    <div class="w">
      <CommentBlock
        v-for="cItem in commentInfo.Children"
        :key="cItem.Id"
        :info="cItem"
        notShowReplay
      />
    </div>
    <sendCommentBar
      v-model="showCommentBox"
      :commentsCount="commentCount"
      :info.sync="currCommentInfo"
      @onSuccess="handleSendComment"
    />
  </div>
</template>
<script>
import sendCommentBar from "@/components/comment/sendCommentBar.vue";
import CommentBlock from "@/components/comment/commentBlock.vue";
export default {
  name: "commentList",
  components: {
    sendCommentBar,
    CommentBlock
  },
  data() {
    return {
      commentInfo: [],
      UserId: 0,
      currCommentInfo: {
        SourceId: this.ArticleId,
        AuthorId: this.AuthorId,
        isFav: this.isFav,
        name: ""
      },
      commentCount: 0,
      showCommentBox: false
    };
  },
  created() {
    let data = this.$route.params.commentList || "{}";
    let info = JSON.parse(data);
    
    if (info.commentInfo) {
      this.commentInfo = info.commentInfo;
      this.currCommentInfo = info.currCommentInfo;
      this.commentCount = info.commentCount;
    }

    this.UserId = this.$mdUtils.getUserInfo("Id");
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    handleSendComment() {}
  }
};
</script>
<style lang='scss' scoped>
</style>